function Storage () {

}

Storage.prototype = {
  get: function (key) { return this[key] },
  set: function (key, value) {
    this[key] = value
  }
 };

const store = (function () {
  let storage

  function init () {
    window.store = new Storage()
    storage = window.store
  }

  function set (key, value) {
    storage.set(key, value)
    let contentWindow = document.getElementById('builder').contentWindow
    contentWindow.postMessage({ event: 'set', key: key, value: value }, '*')
  }
  function get (key) {
    return storage.get(key)
  }
  return {
    init: init,
    get: get,
    set: set
  }
})()
